var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobeSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 68.531 72.828 c -0.256 0 -0.512 -0.098 -0.707 -0.293 l -4.719 -4.719 c -0.391 -0.391 -0.391 -1.023 0 -1.414 s 1.023 -0.391 1.414 0 l 4.719 4.719 c 0.391 0.391 0.391 1.023 0 1.414 C 69.043 72.73 68.787 72.828 68.531 72.828 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 71.828 69.531 c -0.256 0 -0.512 -0.098 -0.707 -0.293 l -4.718 -4.718 c -0.391 -0.391 -0.391 -1.023 0 -1.414 s 1.023 -0.391 1.414 0 l 4.718 4.718 c 0.391 0.391 0.391 1.023 0 1.414 C 72.34 69.434 72.084 69.531 71.828 69.531 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.565 89.997 c -1.393 0 -2.783 -0.529 -3.843 -1.589 L 66.337 74.023 c -0.188 -0.188 -0.293 -0.441 -0.293 -0.707 s 0.105 -0.52 0.293 -0.707 l 6.272 -6.272 c 0.375 -0.375 1.039 -0.375 1.414 0 l 14.385 14.386 c 2.118 2.118 2.118 5.566 0 7.686 l 0 0 C 87.349 89.468 85.957 89.997 84.565 89.997 z M 68.458 73.316 l 13.679 13.678 c 1.337 1.337 3.517 1.339 4.857 0 c 1.339 -1.34 1.339 -3.519 0 -4.857 L 73.316 68.458 L 68.458 73.316 z M 87.701 87.701 h 0.01 H 87.701 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 52.877 71.817 c -4.853 0 -9.706 -1.847 -13.4 -5.541 c -7.389 -7.389 -7.389 -19.41 0 -26.799 c 7.388 -7.389 19.411 -7.389 26.799 0 l 0 0 c 7.389 7.389 7.389 19.411 0 26.799 C 62.582 69.971 57.729 71.817 52.877 71.817 z M 52.877 35.935 c -4.341 0 -8.681 1.652 -11.986 4.957 c -6.608 6.609 -6.608 17.363 0 23.971 c 6.609 6.609 17.362 6.609 23.971 0 c 6.608 -6.608 6.608 -17.362 0 -23.971 C 61.559 37.587 57.217 35.935 52.877 35.935 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 52.877 65.895 c -3.478 0 -6.746 -1.354 -9.205 -3.813 c -2.458 -2.458 -3.813 -5.727 -3.813 -9.204 s 1.354 -6.746 3.813 -9.205 c 2.459 -2.458 5.728 -3.813 9.205 -3.813 s 6.746 1.354 9.204 3.813 l 0 0 l 0 0 c 2.459 2.459 3.813 5.728 3.813 9.205 s -1.354 6.746 -3.813 9.204 C 59.623 64.54 56.354 65.895 52.877 65.895 z M 52.877 41.859 c -2.943 0 -5.71 1.146 -7.791 3.227 c -2.081 2.081 -3.227 4.848 -3.227 7.791 c 0 2.942 1.146 5.709 3.227 7.79 c 2.081 2.081 4.848 3.228 7.791 3.228 c 2.942 0 5.709 -1.146 7.79 -3.228 s 3.228 -4.848 3.228 -7.79 c 0 -2.943 -1.146 -5.71 -3.228 -7.791 l 0 0 C 58.586 43.005 55.819 41.859 52.877 41.859 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 90 C 20.187 90 0 69.813 0 45 C 0 20.187 20.187 0 45 0 c 24.813 0 45 20.187 45 45 c 0 10.349 -3.6 20.453 -10.135 28.452 l -1.549 -1.266 C 84.561 64.544 88 54.889 88 45 C 88 21.29 68.71 2 45 2 C 21.29 2 2 21.29 2 45 c 0 23.71 19.29 43 43 43 c 9.889 0 19.544 -3.438 27.187 -9.683 l 1.266 1.549 C 65.453 86.401 55.349 90 45 90 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 90 c -10.667 0 -19.023 -19.767 -19.023 -45 S 34.333 0 45 0 c 9.432 0 17.333 15.915 18.788 37.842 l -1.996 0.133 C 60.432 17.466 53.212 2 45 2 c -9.228 0 -17.023 19.691 -17.023 43 S 35.772 88 45 88 c 5.485 0 10.869 -7.249 14.051 -18.917 l 1.93 0.525 C 57.499 82.377 51.525 90 45 90 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.89,
    y: 60,
    rx: 0,
    ry: 0,
    width: 17.11,
    height: 2,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 60,
    rx: 0,
    ry: 0,
    width: 32.87,
    height: 2,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 28,
    rx: 0,
    ry: 0,
    width: 81.99,
    height: 2,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeSearch);
export default __webpack_public_path__ + "static/media/globe-search.272aa78f7f2a5f6450d11811d541530c.svg";
export { ForwardRef as ReactComponent };